<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section v-if="page.contentExtra" class="content-section content-extra">
			<div class="row contentblock">
				<div class="columns column6">
					<div class="contentblock-content">
						<span>
							<div v-parse-links v-html="page.contentExtra" />
						</span>
					</div>
				</div>
				<div class="columns column6">
					<picture>
						<source :srcset="page.sideImageWebp" type="image/webp" />
						<source :srcset="page.sideImage" />
						<img :src="page.sideImage" :alt="sideImageAlt" loading="lazy" />
					</picture>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss">
.content-extra {
	background-color: var(--secondary-background-color);
	color: var(--tertiary-background-color);

	.column6 {
		display: flex;

		&:first-child {
			padding-right: 25px;
		}

		.contentblock-content {
			display: flex;
			align-items: center;
			margin-bottom: 30px;
		}
	}
}
</style>
